export const fmtCurrency = (n, opts = {}) => {
  const v = Number(n) || 0;
  return v.toLocaleString("en-US", { style: "currency", currency: "USD", maximumFractionDigits: opts.max ?? 2, minimumFractionDigits: opts.min ?? 2 });
};

export const fmtPct = (n, digits = 2) => {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return "—";
  return `${Number(n).toFixed(digits)}%`;
};

export const fmtNum = (n, digits = 2) => {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return "—";
  return Number(n).toLocaleString("en-US", { maximumFractionDigits: digits, minimumFractionDigits: digits });
};

export const signColor = (n) => {
  const v = Number(n) || 0;
  if (v > 0) return "var(--gain)";
  if (v < 0) return "var(--loss)";
  return "var(--text-secondary)";
};
